import { createRecipe } from './runtime';

const kbdConfig = {"name":"kbd","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const kbd = /* @__PURE__ */ createRecipe(kbdConfig)